import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#EE6A32",
      d: "M11.946 9.213a.734.734 0 0 0-.213.647l.593 3.28a.72.72 0 0 1-.3.72.734.734 0 0 1-.78.053l-2.953-1.54a.754.754 0 0 0-.333-.087h-.18a.544.544 0 0 0-.18.06l-2.954 1.547a.78.78 0 0 1-.473.074.741.741 0 0 1-.594-.848l.594-3.28a.746.746 0 0 0-.213-.652L1.553 6.853a.72.72 0 0 1-.18-.753.749.749 0 0 1 .593-.5l3.313-.48a.741.741 0 0 0 .587-.407l1.46-2.993a.694.694 0 0 1 .133-.18l.06-.047a.447.447 0 0 1 .108-.086l.072-.027.114-.047h.28c.25.026.472.176.587.4l1.48 2.98a.74.74 0 0 0 .553.406l3.313.481c.28.04.514.233.607.5a.724.724 0 0 1-.194.753l-2.493 2.36Z"
    }, null, -1)
  ])))
}
export default { render: render }